import { render } from "./ImmediateTaggingDetail.vue?vue&type=template&id=155c3074&scoped=true"
import script from "./ImmediateTaggingDetail.vue?vue&type=script&lang=js"
export * from "./ImmediateTaggingDetail.vue?vue&type=script&lang=js"

import "./ImmediateTaggingDetail.vue?vue&type=style&index=0&id=155c3074&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155c3074"]])

export default __exports__